/** Categorie tematiche del feed Piazza Social. */
export const WALL_CATEGORIES = [
  { id: "all", label: "Tutti i post", icon: "📱" },
  { id: "storia", label: "Storia e Borghi", icon: "🏛️" },
  { id: "cibo", label: "Enogastronomia", icon: "🍕" },
  { id: "eventi", label: "Eventi", icon: "📅" },
  { id: "trekking", label: "Trekking e Sentieri", icon: "🥾" },
  { id: "cicloturismo", label: "Cicloturismo", icon: "🚴" },
  { id: "mare", label: "Mare e Costa", icon: "🌊" },
  { id: "segnalazioni", label: "Segnalazioni", icon: "🚨" },
];

/**
 * Micro-badge esperienze (stile Komoot) su /piazze.
 * Trinità territoriale: Montagna / Terra e Borghi / Mare e Costa → rotte reali Esplora la Mappa.
 * Altri badge: enogastronomia → API category `cibo`; wallCategory nativi per filtro post.
 */
export const PIAZZE_ESPERIENZE = [
  { id: "tutto", label: "Tutto", icon: "✨", wallCategory: "all" },
  {
    id: "montagna",
    label: "Montagna",
    icon: "⛰️",
    wallCategory: "trekking",
    mapHref: "/esplora-la-mappa?mode=terra&macro=montagna",
    mapTheme: "montagna",
  },
  {
    id: "terra",
    label: "Terra e Borghi",
    icon: "🌿",
    wallCategory: "cicloturismo",
    mapHref: "/esplora-la-mappa?mode=terra&macro=terra",
    mapTheme: "terra",
  },
  {
    id: "mare",
    label: "Mare e Costa",
    icon: "🌊",
    wallCategory: "mare",
    mapHref: "/esplora-la-mappa?mode=mare",
    mapTheme: "mare",
  },
  { id: "enogastronomia", label: "Enogastronomia", icon: "🍝", wallCategory: "cibo" },
  {
    id: "storia",
    label: "Storia e Monumenti",
    icon: "🏛️",
    wallCategory: "storia",
    mapTheme: "storia",
  },
  { id: "eventi", label: "Sagre ed Eventi", icon: "🎉", wallCategory: "eventi" },
];

export function esperienzaMapMeta(esperienzaId) {
  return PIAZZE_ESPERIENZE.find((e) => e.id === esperienzaId) || null;
}
export const TREKKING_TEXT_RE =
  /sentiero|percorso|escursione|trekking|mappa|itinerario/i;

/** Categorie assegnabili a un post (senza "all"). */
export const WALL_POST_CATEGORIES = WALL_CATEGORIES.filter((c) => c.id !== "all");

export const WALL_CATEGORY_IDS = new Set(WALL_POST_CATEGORIES.map((c) => c.id));

export const DEFAULT_WALL_CATEGORY = "storia";

export function wallCategoryMeta(id) {
  return WALL_CATEGORIES.find((c) => c.id === id) || null;
}
